import React from 'react';
import { makeStyles, Select, MenuItem } from '@material-ui/core';
import PropTypes from 'prop-types';
import { DropDownIcon } from '../Icon';
import { initValue } from '../../utils';

const useStyles = makeStyles((theme) => ({
  select: {
    flexGrow: '1',
    height: '3.5rem',
    borderRadius: '0.625rem',
    '& .MuiSelect-icon': {
      margin: '0 1rem 0 1.625rem',
      height: '1.5rem',
      color: '#538fff',
    },
    '& .MuiSelect-root': {
      padding: '0 4.125rem 0 1.25rem',
      height: '100%',
      lineHeight: '3.5rem',
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.875rem',
    },
    '& .MuiSelect-nativeInput': {
      padding: '0 4.125rem 0 1.25rem',
      height: '100%',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'solid 1px #e4e7eb',
      borderRadius: '0.625rem',
    },
    ':before': {
      borderBottom: '0',
    },
  },
}));

export default function SelectFillBorder(props) {
  const classes = useStyles();
  const { className, value, itemList } = props;

  return (
    <Select
      {...props}
      className={className ? `${classes.select} ${className}` : classes.select}
      value={initValue(value)}
      variant="outlined"
      IconComponent={DropDownIcon}
    >
      {itemList.map((item) => {
        return (
          <MenuItem key={item.id} value={item.value}>
            {item.name}
          </MenuItem>
        );
      })}
    </Select>
  );
}

SelectFillBorder.propTypes = {
  itemList: PropTypes.array.isRequired,
};
